import { ClassNameProps, Column, makeClassName, Row, StyleProps } from "@hex-insights/core";
import {
	Message,
	MessageGroupMessagesListQuery,
	UserViewRecordListForTargetWithUserQuery,
} from "../../../../Utilities";
import * as UserComponents from "../../User";
import { AuthorTimestampView } from "../AuthorTimestamp";
import { MessageView } from "../View";
import styles from "./styles.module.css";

export type MessageSectionProps = {
	author: MessageGroupMessagesListQuery["messageConnection"]["edges"][0]["node"]["author"];
	messages: MessageGroupMessagesListQuery["messageConnection"]["edges"][0]["node"][];
	messageViewRecords?: Record<
		Message["id"],
		UserViewRecordListForTargetWithUserQuery["userViewRecordConnection"]["edges"][0]["node"][]
	>;
	isInOneOnOne?: boolean;
} & Partial<ClassNameProps & StyleProps>;

export function MessageSection({
	author,
	messages,
	messageViewRecords,
	isInOneOnOne,
	className,
	style,
}: MessageSectionProps) {
	return (
		<Row
			justify="spaced-start"
			horizontalSpacing="0.875rem"
			className={makeClassName(styles["message-section"], className)}
			style={style}
		>
			<UserComponents.UserIcon user={author} size={46} className={styles["author-icon--large"]} />

			<Column justify="spaced-start" verticalSpacing="0.25rem" className={styles["message-section__main-content"]}>
				<Row justify="spaced-start" align="center" horizontalSpacing="0.625rem">
					<UserComponents.UserIcon user={author} size={30} className={styles["author-icon--small"]} />

					<AuthorTimestampView author={author} createdAt={messages[0].createdAt} style={{ minWidth: 0 }} />
				</Row>

				<Column justify="spaced-start" verticalSpacing="0.5rem" className={styles["message-section__messages"]}>
					{messages.map((message) => (
						<MessageView
							key={message.id}
							message={message}
							viewRecords={messageViewRecords ? messageViewRecords[message.id] : undefined}
							isInOneOnOne={isInOneOnOne}
						/>
					))}
				</Column>
			</Column>
		</Row>
	);
}
